import React from 'react';

const TrustBox = ( props ) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);
    return (
            <div
                ref={ref}
                className="trustpilot-widget width-100"
                data-locale={props.locale}
                data-template-id={props.template}
                data-businessunit-id={props.businessunit}
                data-style-height={props.height || "200px"}
                data-style-width={props.width || "100%"}
                data-theme={props.theme || "light"}
                data-stars={props.stars || "4,5"}
                >
                <a href={props.tpurl} target="_blank" rel="noopener">Trustpilot</a> 
            </div>
            );
};
export default TrustBox;